import { createResponseAlertMessage } from '@au/core/lib/components/objects/AlertMessage';

export function pruneCurrentStatusKeys(data, config, prop = 'currentStatus') {
  const prefixRe = new RegExp(`^${prop}(.+)`);
  const result = {};

  for (const [key, value] of Object.entries(config)) {
    const match = prefixRe.exec(key);
    if (!match) {
      result[key] = value;
      continue;
    }

    const env = match[1].charAt(0).toLowerCase() + match[1].slice(1);
    const val = data.getIn([prop, env]);
    if (val != null) {
      result[key] = value;
    }
  }

  return result;
}

/**
 * Fetches the list of allowed environments via `component.props.endpoint`
 * and stores them in `component.state.allowedEnvs`.
 *
 * NOTE: unlike the rest of this module, this helper has side effects
 * (network call + setState) and expects to be invoked from a React
 * component's componentDidMount, with `_isMounted` managed by the caller.
 */
export function fetchAllowedEnvironments(component) {
  component._isMounted = true;

  component.props.endpoint
    .getAllowedEnvironments()
    .then((resp) => {
      if (component._isMounted) component.setState({ allowedEnvs: resp.data.items || [] });
    })
    .catch((err) => {
      if (component._isMounted) createResponseAlertMessage(err);
    });
}

export function clearMountedFlag(component) {
  component._isMounted = false;
}
